<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 13:35:33
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\RosterFormRecord.vue
 -->
<template>
  <ContentLayout
    pad="0"
    :title="$t('label_essweb_admin_RosterFormRecord_list_title')"
    @activated="activated"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :showSelect="showSelect"
        :filter-page-data="filterPageData"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.number="{ item }">
          <div
            class="text--primary table-title"
            :title="item.roster_form_record_swift_number"
          >
            {{ item.roster_form_record_swift_number }}
          </div>
        </template>
        <template v-slot:item.title="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.roster_form_record_title)"
          >
            {{ $getCommonLangValue(item.roster_form_record_title) }}
          </div>
          <div
            class="table-subtitle text--secondary"
            :title="$getCommonLangValue(item.roster_form_record_description)"
          >
            {{ $getCommonLangValue(item.roster_form_record_description) }}
          </div>
        </template>
        <template v-slot:item.startTime="{ item }">
          {{ $getDateTime(item.roster_utc_start_date, "YYYY/MM/DD") }}
        </template>
        <template v-slot:item.endTime="{ item }">
          {{ $getDateTime(item.roster_utc_end_date, "YYYY/MM/DD") }}
        </template>
        <template v-slot:item.manage="{ item }">
          <div>
            <template
              v-for="(
                it, index
              ) in item.ess_att_roster_form_records_detail_manager"
            >
              <StaffAvatar
                :key="index"
                v-if="index < 3"
                :size="36"
                contentClass="mr-n3"
                :src="it.mrbase_sys_staffs.staff_avatar"
                :staff_name="it.mrbase_sys_staffs.preferred_name"
              />
            </template>
            <span
              class="pl-4"
              v-if="item.ess_att_roster_form_records_detail_manager.length > 3"
              >...{{
                item.ess_att_roster_form_records_detail_manager.length - 3
              }}</span
            >
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-container class="d-flex align-center pa-0 ma-0">
            <v-btn
              icon
              small
              v-if="Number(item.is_locked) == 1"
              :class="item.is_locked == 1 ? 'text--primary' : 'text--secondary'"
            >
              <span class="material-icons-round md-18">{{
                item.is_locked == 1 ? "lock" : "lock_open"
              }}</span>
            </v-btn>
            <!-- <StatusChip
              :slideColor="
                item.status_uuid == 'Draft'
                  ? '#8490AD'
                  : item.status_uuid == 'Publishing' ||
                    item.status_uuid == 'Submiting'
                  ? 'purple'
                  : item.status_uuid == 'Published' ||
                    item.status_uuid == 'Submited'
                  ? 'green'
                  : 'grey'
              "
            >
              <template v-slot:status>
                <template
                  v-if="
                    item.status_name != [] &&
                    item.status_name != '' &&
                    item.status_name != null
                  "
                >
                  {{ $getCommonLangValue(item.status_name) }}
                </template>
                <template v-else>
                  {{ $getCommonLangValue(item.status_value) }}
                </template>
              </template>
            </StatusChip> -->
            <StatusChip
              icon
              :slideColor="item.approval_tint_color"
              :bgColor="item.approval_bg_color"
            >
              <template v-slot:status>
                {{ $getCommonLangValue(item.status_detail) }}
              </template>
            </StatusChip>
          </v-container>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :editBtn="
              item['status_uuid'] === 'Draft' &&
              hasBtn('edit-admin-roster-form-record')
            "
            :delBtn="hasBtn('delete-admin-roster-form-record')"
            :viewBtn="hasBtn('view-admin-roster-form-record')"
            :title="$t('label_essweb_admin_RosterFormRecord_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "RosterRecord",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      search: "",
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_RosterFormRecord_list_swiftNumberLabel",
          value: "number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_list_rosterFormNameLabel",
          value: "title",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.roster_form_record_title
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1 ||
              item.roster_form_record_swift_number
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_RosterFormRecord_list_startDateLabel",
          value: "startTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_list_endDateLabel",
          value: "endTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_list_managersLabel",
          value: "manage",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterPageData: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_RosterFormRecord_list_swiftNumberLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "title",
          position: "right",
          label: "label_essweb_RosterFormRecord_list_rosterFormNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "daterange",
          sequence: 2,
          name: "date",
          position: "right",
          label: "label_essweb_RosterFormRecord_list_startDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          name: "status",
          statusChip: "icon",
          multiple: true,
          label: "label_essweb_RosterFormRecord_list_statusLabel",
          value: "",
          selected: [],
          data: {
            api: "ess_roster_record_status_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "swift_number")
          data["roster_form_record_swift_number"] = item.value;
        if (item["name"] == "title")
          data["roster_form_record_title"] = item.value;
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "status") {
          data["status_list"] = item.value.join(",");
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      })
        .then((res) => {
          that.desserts = res.data;
          that.totalCount = res.totalcount;
          callback ? callback(page, perpage, data) : null;
        })
        .catch(() => {
          callback ? callback(page, perpage, data) : null;
        });
    },
    // toNew: function() {
    //   this.$toPage("/admin/newRosterRecord", {});
    // },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/roster-form-record/edit/"
          : "/admin/roster-form-record/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t(
            "message_essweb_RosterFormRecord_list_deleteRosterFormRecordSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
